import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';
import { mainStore } from '~/stores';

import styles from './CatalogButton.module.scss';
import { SuperMenu } from './components/SuperMenu';
import { SUPER_MENU_DROPDOWN_KEY } from './constants';

export const CatalogButton: React.FC<{ isTablet?: boolean }> = observer(
  ({ isTablet }) => {
    const { t } = useTranslation();
    const showSuperMenu = mainStore.isHeaderDropdownOpen(
      SUPER_MENU_DROPDOWN_KEY,
    );
    const navigate = useNavigate();

    const buttonRef = useRef<Nullable<HTMLButtonElement>>(null);

    const handleCatalogToggle = () => {
      if (company.redirectCatalogToShop) {
        navigate('/shop');
        return;
      }

      mainStore.setHeaderDropdownOpen(SUPER_MENU_DROPDOWN_KEY, !showSuperMenu);
    };

    const handleCloseSuperMenu = () => {
      mainStore.setHeaderDropdownOpen(SUPER_MENU_DROPDOWN_KEY, false);
    };

    return (
      <>
        <Button
          endIcon="catalog-3.1"
          size="M"
          variant="brand"
          onClick={handleCatalogToggle}
          ref={buttonRef}
          className={classes([
            isTablet ? styles.shortBtn : undefined,
            'h-12 max-h-12!',
            'hover:bg-navigation-action-brand-hover! bg-navigation-action-brand! text-navigation-text-in-button!',
          ])}
        >
          {!isTablet && t('header:catalog')}
        </Button>

        <SuperMenu
          isOpen={showSuperMenu}
          onClose={handleCloseSuperMenu}
          buttonRef={buttonRef}
        />
      </>
    );
  },
);
CatalogButton.displayName = 'CatalogButton';
